jQuery(document).ready(function($){
    $('#staticpage-content img').addClass('img-responsive');
    $('#staticpage-content table').addClass('table').wrap('<div class="table-responsive"></div>');
});